import React from 'react';
import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';

interface LeftAccentCardProps {
  /** 左辺のアクセント色 */
  accentColor?: string;
  /** 全体のボーダー色 */
  borderColor?: string;
  /** 角丸の半径 */
  borderRadius?: string | number;
  /** カードの内側余白 */
  padding?: string | number;
  /** 追加のスタイル */
  sx?: SxProps<Theme>;
  /** 子要素 */
  children: React.ReactNode;
}

/**
 * 左辺にアクセントボーダーを持つカード
 * 角丸に沿って左辺のボーダー色が変わるデザイン
 */
const LeftAccentCard: React.FC<LeftAccentCardProps> = ({
  accentColor = '#e53935',
  borderColor = '#ffd0cc',
  borderRadius = '7.25px',
  padding = '14px 32px',
  sx,
  children,
}) => {
  const radiusValue = typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius;

  return (
    <Box
      sx={{
        position: 'relative',
        borderRadius: radiusValue,
        p: padding,
        bgcolor: 'white',
        boxShadow: '0 1px 6px rgba(0,0,0,0.07)',
        // 全体のボーダー
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          borderRadius: radiusValue,
          padding: '2px',
          background: borderColor,
          WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          WebkitMaskComposite: 'xor',
          maskComposite: 'exclude',
          pointerEvents: 'none',
        },
        // 左辺だけアクセント色（角丸に沿う）
        '&::after': {
          content: '""',
          position: 'absolute',
          inset: 0,
          borderRadius: radiusValue,
          padding: '2px',
          background: accentColor,
          WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          WebkitMaskComposite: 'xor',
          maskComposite: 'exclude',
          clipPath: 'polygon(0 0, 7px 0, 7px 100%, 0 100%)',
          pointerEvents: 'none',
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default LeftAccentCard;
